import { atom } from 'recoil';

export const hideEmployeesAtom = atom<boolean>({
	key: 'hideEmployees',
	default: false,
});
